export default __webpack_public_path__ + "app/components/widgets/countryMapW/countryMapWidget.html";